import React, { ReactNode } from 'react'
import { colors, HeartIcon, StarIcon, ThumbsupIcon } from '@diversioteam/diversio-ds'

import { PulseSurveyDisplaySubType, PulseSurveyWeight } from 'api/actions/pulseSurveys/pulseSurveysActions.types'

export const RATING_TYPES: { label: ReactNode; value: PulseSurveyDisplaySubType }[] = [
    { label: <StarIcon type="bold" color={colors.tangerineSharp} />, value: 'star' },
    { label: <HeartIcon type="bold" color={colors.lobsterSharp} />, value: 'heart' },
    { label: <ThumbsupIcon type="bold" color={colors.blue50} />, value: 'thumb' },
]

export const RATING_WEIGHTS: { label: string; value: PulseSurveyWeight }[] = [
    { label: '3', value: 3 },
    { label: '5', value: 5 },
    { label: '10', value: 10 },
]
